// Ported from design/project/App36-OpponentLeft.dc.html by design/preview/to_tsx.py. Change the design first, then this.
export function App36_OpponentLeft() {
  return (
    <>
      <div className="screen">
  <div className="orbL" aria-hidden="true" style={{ top: "60px", left: "-200px", width: "440px", height: "440px" }}></div>
  <div className="pad squeeze" style={{ height: "100%", paddingBottom: "44px" }}>
    <div className="top">
      <span className="chip chipR"><span className="mono">01:12</span> LIVE</span>
    </div>

    <div style={{ marginTop: "50px", display: "flex", alignItems: "center", justifyContent: "center", gap: "22px" }}>
      <div className="av" style={{ width: "84px", height: "84px", background: "#CCFF00", fontSize: "24px", boxShadow: "0 0 30px rgba(204,255,0,0.4)" }}>DK</div>
      <svg width="40" height="20" viewBox="0 0 40 20" aria-hidden="true"><path d="M2 10h10M16 10h8M28 10h10" stroke="#30363D" strokeWidth="3" strokeLinecap="round"></path></svg>
      <div style={{ position: "relative" }}>
        <div className="av" style={{ width: "84px", height: "84px", background: "#30363D", color: "#8B949E", fontSize: "24px" }}>BR</div>
        <span style={{ position: "absolute", right: "-4px", bottom: "-4px", width: "30px", height: "30px", borderRadius: "50%", background: "#0B0E14", border: "2px solid #30363D", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8B949E" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M2 8.5a15 15 0 0 1 20 0M8.5 15.5a5 5 0 0 1 7 0M3 3l18 18"></path></svg>
        </span>
      </div>
    </div>

    <h1 className="h1" style={{ marginTop: "30px", textAlign: "center" }}>@bearlord went offline</h1>
    <p className="muted" style={{ margin: "10px 4px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px" }}>Rage quit or bad signal, it doesn't matter. Their stake is locked and the battle runs to the end.</p>

    <div className="g" style={{ marginTop: "24px", borderRadius: "20px", padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
      <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
        <svg width="20" height="20" viewBox="0 0 24 24" style={{ flex: "none" }} aria-hidden="true"><circle cx="12" cy="12" r="10" fill="#CCFF00"></circle><path d="M7 12.5 L10.5 16 L17 9" stroke="#0B0E14" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg>
        <span style={{ fontSize: "13px", lineHeight: "19px" }}>The oracle still decides at 00:00. Leaving doesn't change the result.</span>
      </div>
      <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
        <svg width="20" height="20" viewBox="0 0 24 24" style={{ flex: "none" }} aria-hidden="true"><circle cx="12" cy="12" r="10" fill="#CCFF00"></circle><path d="M7 12.5 L10.5 16 L17 9" stroke="#0B0E14" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg>
        <span style={{ fontSize: "13px", lineHeight: "19px" }}>If you're right, the victory payout comes to you as normal.</span>
      </div>
    </div>

    <div style={{ marginTop: "16px", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 16px", borderRadius: "18px", background: "rgba(204,255,0,0.08)", border: "1px solid rgba(204,255,0,0.4)" }}>
      <span style={{ fontSize: "13px" }}>You're leading</span>
      <span className="mono lime" style={{ fontWeight: "800", fontSize: "16px" }}>+0.19%</span>
    </div>

    <div style={{ marginTop: "auto" }}>
      <a href="#/App14" className="btnP">BACK TO THE ARENA</a>
    </div>
  </div>
</div>
    </>
  );
}
